// src/modules/app-views/_apps/appmulti/plans/pages/Init/components/PlansGlobalSearch/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useListContext } from 'components/core/ListProvider';

import translateX from 'utils/translateX';
import './PlansGlobalSearch.less';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const DEBOUNCE_MS = 300;

// *******************************************************************************
// COMPONENT
// *******************************************************************************
const PlansGlobalSearch = ({ className }) => {
  const { setTextSearch } = useListContext() || {};

  const [searchValue, setSearchValue] = useState('');
  const debounceRef = useRef(null);

  // On mount: clear any persisted textSearch in URL params (?q=).
  // Field always starts empty — stale URL filter must not remain active.
  useEffect(() => {
    setTextSearch?.('');
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = useCallback(
    e => {
      const value = e?.target?.value ?? '';
      setSearchValue(value);

      if (debounceRef.current) clearTimeout(debounceRef.current);

      if (!value.trim()) {
        setTextSearch?.('');
      } else {
        debounceRef.current = setTimeout(() => {
          setTextSearch?.(value.trim());
        }, DEBOUNCE_MS);
      }
    },
    [setTextSearch]
  );

  return (
    <Input
      className={`plans-global-search ${className ?? ''}`}
      placeholder={translateX('search_plan')}
      prefix={<SearchOutlined />}
      allowClear
      size="middle"
      value={searchValue}
      onChange={handleChange}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default PlansGlobalSearch;
